export enum NewsType {
  RELEVANT = 'Relevant',
  CHRONOLOGICAL = 'Chronological',
  STORIES = 'Stories',
  EVENTS = 'Events',
  BOOKMARKED = 'Bookmarked',
  FLAGGED = 'Flagged',
  DISMISSED = 'Dismissed',
}

export enum DialogResponse {
  AUDITED = 'audited',
  DISMISSED = 'dismissed',
  CHANGED = 'changed',
  RESOLVED = 'resolved',
}

export const REFRESH_PARAMS = [
  'update',
  'updatePayload',
  'type',
  'id',
  'isin',
  'time',
  'period',
  'lang',
  'feed',
  'categories',
  'continents',
  'countries',
  'factuality',
  'temporality',
  'ranks',
  'panels',
  'tag',
  'participant',
  'newsday',
  'newstype',
  'eventid',
  'event_ids',
  'filter',
  'noise',
  'license',
  'duplicate',
  'title',
  'newsaudit',
  'newsfeedFromQuery',
  'factuality',
  'temporality',
  'sentence_with_entity_threshold',
  'entity_span_threshold',
  'high_entity_article_threshold',
  'elasticsearch_score_decay',
  'entity_boost',
];

export const MainNewsfeedREFRESH_PARAMS = [
  'update',
  'updatePayload',
  'updateNewsfeed',
  'type',
  'id',
  'isin',
  'time',
  'period',
  'lang',
  'feed',
  'categories',
  'continents',
  'countries',
  'factuality',
  'temporality',
  'ranks',
  'panels',
  'tag',
  'participant',
  'newsday',
  'newstype',
  'eventid',
  'event_ids',
  'filter',
  'noise',
  'license',
  'duplicate',
  'title',
  'newsaudit',
  'newsfeedFromQuery',
  'factuality',
  'temporality',
  'sentence_with_entity_threshold',
  'entity_span_threshold',
  'high_entity_article_threshold',
  'elasticsearch_score_decay',
  'entity_boost',
];
